import { Guardian } from '@xaamin/guardian';

Guardian.define('cancelacion.masiva.subir.archivo', (user) => {
  return user.can('cancelacion.masiva.subir.archivo');
});

Guardian.define('cancelacion.masiva.listar.archivos', (user) => {
  return user.can('cancelacion.masiva.listar.archivos');
});

Guardian.define('cancelacion.masiva.listar.tickets', (user) => {
  return user.can('cancelacion.masiva.listar.tickets');
});

Guardian.define('cancelacion.masiva.descargar.excel.procesado', (user) => {
  return user.can('cancelacion.masiva.descargar.excel.procesado');
});

Guardian.define('cancelacion.masiva.descargar.archivo.original', (user) => {
  return user.can('cancelacion.masiva.descargar.archivo.original');
});